import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M20.65,16.06h-.91v1.75h1a1.44,1.44,0,0,0,.89-.23.83.83,0,0,0,.29-.69C21.87,16.34,21.46,16.06,20.65,16.06Z"/><path d="M29,6H3A1,1,0,0,0,2,7V25a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V7A1,1,0,0,0,29,6ZM15.67,19H14l-.93-3.54q0-.18-.18-.78c-.08-.39-.13-.66-.14-.79,0,.16-.07.43-.14.8s-.13.63-.17.78L11.52,19H9.86L8.11,12.26H9.54l.88,3.67c.16.68.27,1.27.34,1.77,0-.18.06-.45.13-.82a7.12,7.12,0,0,1,.19-.85l1-3.77h1.38l1,3.77c0,.17.1.43.16.77s.12.65.15.9q0-.36.15-.9c.07-.36.13-.65.19-.87L16,12.26h1.43Zm7-.52a2.94,2.94,0,0,1-1.84.52H18.29V12.26h2.13a4.12,4.12,0,0,1,2.13.41A1.4,1.4,0,0,1,23.21,14a1.64,1.64,0,0,1-.29,1,1.18,1.18,0,0,1-.77.47v0a1.52,1.52,0,0,1,.94.54,1.65,1.65,0,0,1,.29,1A1.67,1.67,0,0,1,22.7,18.47Z"/><path d="M21.45,14.74a.67.67,0,0,0,.26-.59.57.57,0,0,0-.29-.55,1.77,1.77,0,0,0-.91-.17h-.77v1.49h.85A1.6,1.6,0,0,0,21.45,14.74Z"/>';
export var WhiteBalanceSVG = function WhiteBalanceSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
WhiteBalanceSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(WhiteBalanceSVG);